import React from 'react';

export default function Contact() {
    return (
        <section id="contact" className="px-5 lg:px-10 py-10 w-full my-20 max-w-5xl mx-auto bg-orange-100">
            <h2 className="text-5xl font-bold text-orange-400 text-center mb-8">
                Contact Us:
            </h2>
            <div className="flex flex-col sm:flex-row gap-5 justify-center my-10">
                <a 
                    rel="noreferrer"
                    target="_blank"
                    className="text-center hover:underline flex items-center gap-2 transition duration-300"
                    href="https://t.me/abenezer_merjan"
                    aria-label="Contact us on Telegram"
                >
                    <img src="/images/telegram.png" alt="Telegram logo" className="w-6 h-6" />
                    Telegram
                </a>
                <a 
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-center hover:underline flex items-center gap-2 transition duration-300"
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=melasoftwares@gmail.com"
                    aria-label="Send us an email"
                >
                    <img src="/images/gmail.png" alt="Gmail logo" className="w-6 h-6" />
                    E-mail
                </a>
                <div className="text-center flex items-center gap-2">
                    <img src="/images/call.png" alt="Phone icon" className="w-6 h-6" />
                    +251 94 770 8731
                </div>
            </div>
        </section>
    );
}